import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Self-hosted fonts + icons (no CDN → CSP-safe; Vite fingerprints the assets).
// Chakra Petch = display (headlines, names, buttons), Archivo = body,
// Chakra Petch also carries labels and tabular readouts.
// The pairing is ported from the portfolio's mission-console system.
import "@fontsource/chakra-petch/400.css";
import "@fontsource/chakra-petch/500.css";
import "@fontsource/chakra-petch/600.css";
import "@fontsource/chakra-petch/700.css";
import "@fontsource/archivo/400.css";
import "@fontsource/archivo/500.css";
import "@fontsource/archivo/600.css";
import "@fontsource/archivo/700.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import "./styles/tokens.css";
import "./styles/global.css";
import "./design-system/components.css";
import "./styles/console.css";
import "./styles/details.css";
import App from "./app/App";
import { useHudStore } from "./store/hudStore";
import { initHistorySync } from "./lib/history";

// Dev-only: expose the store so the HUD's empty state can be inspected without a
// live sign-in. Stripped from production builds by the import.meta.env.DEV guard.
if (import.meta.env.DEV) (window as unknown as { __store: typeof useHudStore }).__store = useHudStore;

// Bridge screen navigation into browser history so Back/Forward work. At module
// scope (not a component effect) so StrictMode's double-invoke can't subscribe twice.
initHistorySync();

const el = document.getElementById("root");
if (!el) throw new Error("Missing #root element");
createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
